import { formatDateStringForApi } from "@flixbus-phx/marketplace-common";
import { RideFilter } from "../../../state/useRideFilter/useRideFilter";
import { RideFilterInput } from "../../types/schema";
import { getContractPartner } from "../selectedContractPartner/selectedContractPartner";

export default (
  rideFilter: RideFilter,
  excludeHideCompletedRides: boolean,
  excludeAllFilters: boolean
): RideFilterInput => {
  const optionalValues = excludeAllFilters
    ? undefined
    : {
        lineId: rideFilter.lineId?.length ? rideFilter.lineId : undefined,
        departureStationId: rideFilter.departureStationId?.length ? rideFilter.departureStationId : undefined,
        departureTime: rideFilter.departureTime.length ? rideFilter.departureTime : undefined,
        hideCompletedRides: excludeHideCompletedRides ? undefined : rideFilter.hideCompletedRides,
        departureDays: rideFilter.departureDays.length ? rideFilter.departureDays : undefined,
      };

  return {
    start: `${formatDateStringForApi(rideFilter.period.startDate)}T00:00`,
    end: `${formatDateStringForApi(rideFilter.period.endDate)}T23:59`,
    contractPartnerId: getContractPartner().contractPartnerId,
    ...optionalValues,
  };
};
